export const Config = {
  API_URL: process.env.NEXT_PUBLIC_API_URL,
  GOOGLE_ANALYTICS_ID: '',
};
